module.exports = __webpack_public_path__ + "media/images/avatar/14-9697c7c7678559b6001246a3106cb960.svg";